import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "settings__section dashboard__section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Organization Settings", -1)
const _hoisted_3 = { class: "settings__label" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Organization Name ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " What your organization will be referred to as ", -1)
const _hoisted_6 = { class: "settings__label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Subdomain ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" .steamcord.link ")
const _hoisted_9 = { class: "settings__setting-description" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" The subdomain players will use to access your site, eg. ")
const _hoisted_11 = { class: "anchor--primary" }
const _hoisted_12 = { class: "settings__label" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Vanity Domain ")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Pending ")
const _hoisted_16 = {
  key: 1,
  class: "danger"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Error ")
const _hoisted_18 = {
  key: 2,
  class: "success"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Secure ")
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { class: "settings__setting-description" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" An optional custom domain used to access your site, eg. ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", { class: "anchor--primary" }, " link.yourdomain.com", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(". See ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" how to configure your vanity domain")
const _hoisted_26 = { class: "settings__label" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Title ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The title shown in your linking site's browser tab ", -1)
const _hoisted_29 = { class: "settings__label" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Favicon URL ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The icon shown in your linking site's browser tab ", -1)
const _hoisted_32 = { class: "settings__label" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Logo URL ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The logo shown in your site's header ", -1)
const _hoisted_35 = { class: "switch-group__item" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Allow Multiple Accounts per Service ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " Whether to allow players to link multiple accounts per service, e.g. multiple Discord accounts ", -1)
const _hoisted_38 = { class: "settings__label" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Rewards Text ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The text shown at the top of your site: wrap text in backticks (`) to be displayed as a command ", -1)
const _hoisted_41 = { class: "settings__section dashboard__section" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Discord Settings", -1)
const _hoisted_43 = { class: "settings__label" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Discord Guild ID ")
const _hoisted_45 = { class: "settings__input-container input-button-group overflow-container" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Connect to Guild ")
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " Click the button above to add Steamcord to your Discord guild ", -1)
const _hoisted_48 = { class: "settings__label" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Discord Role ID ")
const _hoisted_50 = { class: "settings__setting-description" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" The role given when players meet all requirements below. See ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" how to get your Discord role ID")
const _hoisted_53 = { class: "switch-group" }
const _hoisted_54 = { class: "switch-group__item" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Discord Guild Booster ")
const _hoisted_56 = { class: "switch-group__item" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Steam Linked ")
const _hoisted_58 = { class: "switch-group__item" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Steam Group Member ")
const _hoisted_60 = { class: "settings__label" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Discord Guild Invite URL ")
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " A permanent invite link to your Discord guild ", -1)
const _hoisted_63 = { class: "settings__label" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Discord Text ")
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The text shown in the Discord section of your site ", -1)
const _hoisted_66 = { class: "settings__section dashboard__section" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Steam Settings", -1)
const _hoisted_68 = { class: "settings__label" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Steam Group ID ")
const _hoisted_70 = { class: "settings__setting-description" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" See ")
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" how to get your Steam group ID")
const _hoisted_73 = { class: "settings__label" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Steam Group URL ")
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The link to your Steam group ", -1)
const _hoisted_76 = { class: "settings__label" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Steam Rewards Text ")
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", { class: "settings__setting-description" }, " The text shown in the Steam section of your site ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_input_text_group = _resolveComponent("input-text-group")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_external_anchor = _resolveComponent("external-anchor")!
  const _component_base_switch = _resolveComponent("base-switch")!
  const _component_base_text_area = _resolveComponent("base-text-area")!
  const _component_save_popup = _resolveComponent("save-popup")!

  return (_openBlock(), _createElementBlock("form", {
    class: "settings",
    onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.nameError,
            modelValue: _ctx.settings.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.name) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_input_text_group, {
            class: "settings__input",
            error: _ctx.settingsErrors.slugError,
            modelValue: _ctx.settings.slug,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settings.slug) = $event)),
            modelModifiers: { trim: true }
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["error", "modelValue"])
        ]),
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("a", _hoisted_11, " https://" + _toDisplayString(!!_ctx.settings.slug ? _ctx.settings.slug : 'your-subdomain') + ".steamcord.link ", 1)
        ])
      ]),
      (_ctx.isProPlan)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_input_text_group, {
                  class: "settings__input",
                  modelValue: _ctx.settings.vanityDomain.domain,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.vanityDomain.domain) = $event)),
                  modelModifiers: { trim: true }
                }, {
                  default: _withCtx(() => [
                    (_ctx.vanityDomainPending)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_fa_icon, {
                            class: "fa-spin",
                            icon: ['far', 'spinner-third']
                          })
                        ]))
                      : (_ctx.vanityDomainErrored)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _hoisted_17,
                            _createVNode(_component_fa_icon, { icon: ['far', 'exclamation-triangle'] })
                          ]))
                        : (_ctx.vanityDomainActive)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_fa_icon, { icon: ['fas', 'lock'] })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, " No Domain Set "))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("p", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _createVNode(_component_external_anchor, {
                  href: "https://docs.steamcord.io/#vanity-domain-pro-only",
                  class: "anchor--primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_base_input, {
                  class: "settings__input",
                  modelValue: _ctx.settings.title,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.title) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_base_input, {
                  class: "settings__input",
                  error: _ctx.settingsErrors.faviconURIError,
                  modelValue: _ctx.settings.faviconUri,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.faviconUri) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["error", "modelValue"])
              ]),
              _hoisted_31
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.logoURIError,
            modelValue: _ctx.settings.logoUri,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings.logoUri) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _hoisted_34
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_base_switch, {
            modelValue: _ctx.settings.allowMultipleAccounts,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settings.allowMultipleAccounts) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_37
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_38, [
          _hoisted_39,
          _createVNode(_component_base_text_area, {
            class: "settings__text-area",
            modelValue: _ctx.settings.rewardsText,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.rewardsText) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_40
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_base_input, {
              class: "input-button-group__input",
              readonly: "",
              modelValue: _ctx.settings.discordGuildId
            }, null, 8, ["modelValue"]),
            _createVNode(_component_external_anchor, {
              href: `https://discord.com/api/oauth2/authorize?client_id=899026320623804486&permissions=268435457&redirect_uri=https%3A%2F%2Fsteamcord.io%2Fdashboard%2Fsettings&response_type=code&scope=identify%20bot%20applications.commands&state=${_ctx.$route.params.subdomain}`,
              class: "button--inverted input-button-group__button",
              "show-icon": false
            }, {
              default: _withCtx(() => [
                _hoisted_46,
                _createVNode(_component_fa_icon, { icon: ['fab', 'discord'] })
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ]),
        _hoisted_47
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_48, [
          _hoisted_49,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.discordRoleIDError,
            modelValue: _ctx.settings.discordRoleId,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.discordRoleId) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _createElementVNode("p", _hoisted_50, [
          _hoisted_51,
          _createVNode(_component_external_anchor, {
            href: "https://docs.steamcord.io/#discord-role-id",
            class: "anchor--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("label", _hoisted_54, [
          _hoisted_55,
          _createVNode(_component_base_switch, {
            modelValue: _ctx.settings.discordRoleRequirements.discordGuildBooster,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.settings.discordRoleRequirements.discordGuildBooster) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("label", _hoisted_56, [
          _hoisted_57,
          _createVNode(_component_base_switch, {
            modelValue: _ctx.settings.discordRoleRequirements.steam,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.settings.discordRoleRequirements.steam) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("label", _hoisted_58, [
          _hoisted_59,
          _createVNode(_component_base_switch, {
            modelValue: _ctx.settings.discordRoleRequirements.steamGroupMember,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.settings.discordRoleRequirements.steamGroupMember) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_60, [
          _hoisted_61,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.discordInviteError,
            modelValue: _ctx.settings.discordGuildInviteUri,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.settings.discordGuildInviteUri) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _hoisted_62
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_63, [
          _hoisted_64,
          _createVNode(_component_base_text_area, {
            class: "settings__text-area",
            name: "discordText",
            modelValue: _ctx.settings.discordRewardsText,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.settings.discordRewardsText) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_65
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _hoisted_67,
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_68, [
          _hoisted_69,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.steamIDError,
            modelValue: _ctx.settings.steamGroupId,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.settings.steamGroupId) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _createElementVNode("p", _hoisted_70, [
          _hoisted_71,
          _createVNode(_component_external_anchor, {
            href: "https://docs.steamcord.io/#steam-group-id",
            class: "anchor--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_72
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_73, [
          _hoisted_74,
          _createVNode(_component_base_input, {
            class: "settings__input",
            error: _ctx.settingsErrors.steamURIError,
            modelValue: _ctx.settings.steamGroupUri,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.settings.steamGroupUri) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"])
        ]),
        _hoisted_75
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_76, [
          _hoisted_77,
          _createVNode(_component_base_text_area, {
            class: "settings__input",
            modelValue: _ctx.settings.steamRewardsText,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.settings.steamRewardsText) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_78
      ])
    ]),
    _createVNode(_component_save_popup, {
      loading: _ctx.loading,
      show: _ctx.settingsChanged
    }, null, 8, ["loading", "show"])
  ], 32))
}